import React from "react";
import { Route } from "react-router-dom";
import FinanceDashboard from "../../../pages/Views/CorporateResource/FinanceDashboard";
import {
	RevenueReport,
	FinancialReport,
	PaymentsDueAlert,
	UncollectedReport,
	FinancialSummaryReport,
	ArrearReports,
	ArrearReport2,
	FinancialReport2,
	
	
} from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import CollectPayment from "../../../pages/Views/CorporateResource/FinanceView/Forms/CollectPayment";
import FinanceRuleSettingsForm from "../../../pages/Views/CorporateResource/Head/Forms/FinanceRuleSettingsForm";
import ImportExistingCollection from "../../../pages/Views/CorporateResource/Head/ImportExistingCollection";
import ApproveImport from "../../../pages/Views/CorporateResource/Head/Forms/ApproveImport";
export default function CorporateReourceHeadRoutes() {
	return (
		<>


			<Route path="/arrear" element={<ArrearReport2 />} /> 
			
			<Route path="/financeSummary" element={<RevenueReport/>} />
			<Route path="/financialReports" element={<FinancialReport2 />} />
			
			
			// Temporarily add this to your main App.jsx
			{/* <Route path="/approveImport" element={<ApproveImport />} /> */}
			<Route path="/collectPayment" element={<CollectPayment />} />
			<Route path="/financeSummary" element={<FinancialSummaryReport />} />
			<Route path="/financialReports" element={<FinancialReport />} />
			<Route path="/paymentsDue" element={<PaymentsDueAlert />} />
			<Route path="/uncollected" element={<UncollectedReport />} />
			{/* <Route path="/financeRule" element={<FinanceRuleSettingsForm />} /> */}
			<Route path="/importExistingCollection" element={<ImportExistingCollection />} />
			
		</>
	);
}
